import { useLocale } from 'next-intl';

export const useUrl = () => {
  const locale = useLocale();
  const isProduction = process.env.NEXT_PUBLIC_ENV === 'production';

  const getAppUrl = (path?: string) => {
    const subdomain = !isProduction ? 'staging' : 'app';

    if (locale === 'fr') {
      const finalPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
      return `https://${subdomain}.makemycv.fr${finalPath}`;
    }

    const finalPath = path ? `/${locale}${path.startsWith('/') ? path : `/${path}`}` : `/${locale}`;
    return `https://${subdomain}.makemycv.com${finalPath}`;
  };

  return { getAppUrl, locale };
};
